import type { PublicAuthorSearchDoc, SearchResultItem } from '../types';

export function mapAuthorsToSearchResults(docs: PublicAuthorSearchDoc[]): SearchResultItem[] {
  return docs.map((author) => ({
    id: author.id,
    title: author.name?.trim() || author.username?.trim() || `Автор #${author.id}`,
    type: 'author',
    heroImage: author.avatarUrl
      ? { url: author.avatarUrl, thumbnailURL: author.avatarUrl }
      : undefined,
  }));
}
